import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, X } from "lucide-react";

const TYPES = ["Phone Call", "Email", "In Person Visit", "Scheduled Visit"];
const today = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };
const inp = "w-full h-11 px-3 border border-zinc-300 bg-white text-base outline-none focus:border-[#D4AF37]";

export function LogEventSheet({ customerId, defaultType, defaultContact, onClose, onSaved }) {
  const [f, setF] = useState({ event_type: defaultType, call_date: today(), visit_time: "", contact: defaultContact, outcome: "", notes: "", follow_up_date: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const isVisit = f.event_type.includes("Visit");

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post(`/crm/customers/${customerId}/calls`, { ...f, visit_time: isVisit ? f.visit_time : "" });
      toast.success(`${f.event_type} logged`);
      onSaved();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not save");
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-[#0F172A]/60 flex items-end" onClick={onClose} data-testid="m-log-sheet">
      <form onSubmit={save} onClick={(e) => e.stopPropagation()} className="w-full bg-white max-h-[92dvh] overflow-y-auto animate-in slide-in-from-bottom duration-200" style={{ paddingBottom: "max(env(safe-area-inset-bottom), 16px)" }}>
        <div className="sticky top-0 bg-white flex items-center justify-between px-4 py-3 border-b border-zinc-200">
          <h3 className="font-display font-bold text-lg text-[#0F172A]">Log event</h3>
          <button type="button" onClick={onClose} data-testid="m-log-close" className="p-1 text-zinc-400"><X className="h-5 w-5" /></button>
        </div>
        <div className="p-4 space-y-3">
          <div className="grid grid-cols-2 gap-2">
            {TYPES.map((t) => (
              <button type="button" key={t} onClick={() => setF({ ...f, event_type: t })} data-testid={`m-log-type-${t.toLowerCase().replace(/ /g, "-")}`}
                className={`py-2.5 text-sm font-medium border ${f.event_type === t ? "bg-[#0F172A] text-white border-[#0F172A]" : "bg-white text-zinc-600 border-zinc-300"}`}>{t}</button>
            ))}
          </div>
          <div className={`grid gap-2 ${isVisit ? "grid-cols-2" : "grid-cols-1"}`}>
            <label className="text-xs text-zinc-500">Date<input type="date" value={f.call_date} onChange={set("call_date")} required data-testid="m-log-date" className={`${inp} mt-1`} /></label>
            {isVisit && <label className="text-xs text-zinc-500">Time<input type="time" value={f.visit_time} onChange={set("visit_time")} data-testid="m-log-time" className={`${inp} mt-1`} /></label>}
          </div>
          <label className="block text-xs text-zinc-500">Contact<input value={f.contact} onChange={set("contact")} data-testid="m-log-contact" className={`${inp} mt-1`} /></label>
          <label className="block text-xs text-zinc-500">Outcome<input value={f.outcome} onChange={set("outcome")} placeholder="e.g. Left voicemail, Sent quote" data-testid="m-log-outcome" className={`${inp} mt-1`} /></label>
          <label className="block text-xs text-zinc-500">Notes<textarea value={f.notes} onChange={set("notes")} rows={3} data-testid="m-log-notes" className="w-full mt-1 px-3 py-2 border border-zinc-300 text-base outline-none focus:border-[#D4AF37]" /></label>
          <label className="block text-xs text-zinc-500">Follow-up date (optional)<input type="date" value={f.follow_up_date} onChange={set("follow_up_date")} data-testid="m-log-followup" className={`${inp} mt-1`} /></label>
          <button disabled={saving} data-testid="m-log-save" className="w-full h-12 bg-[#0F172A] text-white font-medium flex items-center justify-center gap-2 disabled:opacity-60">
            {saving && <Loader2 className="h-4 w-4 animate-spin" />} Save {f.event_type}
          </button>
        </div>
      </form>
    </div>
  );
}
